// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
// types
// hooks
import Iconify from 'src/components/iconify';

import { useTranslate } from '../../../../locales';
import { IPaymentCard } from '../../../../types/payment';
// components
import PaymentCardItem from './payment/payment-card-item';
import { useBoolean } from '../../../../hooks/use-boolean';
import PaymentNewCardDialog from './payment/payment-new-card-dialog';
import BankAccount from './bank-account';
//

// ----------------------------------------------------------------------

type Props = {
  cards: IPaymentCard[];
};

export default function AccountBillingPayment({ cards }: Props) {
  const newCard = useBoolean();
  const { t } = useTranslate();
  return (
    <>
      <Card sx={{ my: 3 }}>
        <CardHeader
          title={t('Bank Accounts')}
          action={
            <Button
              size="small"
              color="primary"
              startIcon={<Iconify icon="mingcute:add-line" />}
              onClick={newCard.onTrue}
            >
              {`${t('חשבון חדש')}`}
            </Button>
          }
        />

        <Box
          rowGap={2.5}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
          sx={{ p: 3 }}
        >
          <BankAccount />
        </Box>
      </Card>

      <PaymentNewCardDialog open={newCard.value} onClose={newCard.onFalse} />
    </>
  );
}
